module.exports = __webpack_public_path__ + "static/media/left_arrow.2755272f.svg";